import React from 'react'
import ContactPage from '../pages/ContactPage'

function Contact() {
  return (
    <ContactPage/>
  )
}

export default Contact